
















































































































































































































































/** @format */

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { getPassRuleDetailAPI, editPassRuleAPI } from '@/api/setting-management';
import Utils from '@root/utils/common';
import LangCar from './lang-car.vue';

@Component({
  components: {
    LangCar
  }
})
export default class PassRuleEdit extends Vue {
  private title: string = '规则详情';
  // 表单布局
  private formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 }
    }
  };
  plainOptions = [{ label: '启用优先车辆', value: '01' }];
  value = [];
  spinning = false;
  private form: any = null;
  masterSaveCarFlag: boolean = true;
  // 限制项列表
  private limitListData: any[] = [
    {
      label: '不限',
      value: '0'
    },
    {
      label: '限制',
      value: '1'
    }
  ];
  private configName = window.VUE_APP_SERVER_CONFIG.APP_ENV;

  onChange() {
    this.formParams.masterSlaveCar = this.value.length > 0 ? '01' : '00';
    this.editInfo.masterSlaveCar = this.value.length > 0 ? '01' : '00';
  }
  paySourceOption: any[] = Utils.toLabelVal(
    this.$store.state.dictionaries.allDictionaries.unconscious_pay_source || {}
  );
  // 表单需要的参数
  private formParams: any = {
    changeCar: '01', //换车规则 00：场外换车 01：场内换车
    masterSlaveCar: '00', //优先车辆，00：不启用 01：启用
    propertyExceedNumType: '', // 产权车辆：一位多车数量
    propertyExceedNum: '', // 产权一位多车数量(0:不限制)
    propertyGracePeriodType: '2', // 产权车辆：免费宽限期
    propertyGracePeriod: '', // 产权宽限期(0:不限制)
    monthExceedNumType: '', // 长租车辆：一位多车数量
    monthExceedNum: '', // 月卡一位多车数量(0:不限制)
    monthGracePeriodType: '', // 长租车辆：免费宽限期
    monthGracePeriod: '', // 月卡宽限期(0:不限制)
    monthRetentionPeriod: null, // 月卡保留期(0:不限制,9999:无限)
    unconsciousPay: '00', //00不启用
    unconsciousPayFlag: false,
    unconsciousPaySource: '',
    freeTime: 0 //出场时间
  };

  // 编辑表单
  private editInfo: any = {
    ...this.formParams
  };

  // 编辑详情数据
  private detailData: any = null;

  private isDisabled: boolean = true;
  private pkUniformruleId: any = null;
  // 车场ID
  @Prop({ type: String, default: '' })
  parkId!: string;

  // 对车场ID监听
  @Watch('parkId', { immediate: true })
  onChangeParkId() {
    this.initData();
  }

  // 监听产权车辆：一位多车数量
  @Watch('editInfo.propertyExceedNumType', { immediate: true })
  onChangePropertyExceedNumType(newVal: string) {
    if (newVal !== '1') {
      // 不限
      this.editInfo.propertyExceedNum = '';
    }
  }

  // 监听产权车辆：免费宽限期天数
  @Watch('editInfo.propertyGracePeriodType', { immediate: true })
  onChangePropertyGracePeriodType(newVal: string) {
    if (newVal !== '1') {
      // 不限
      this.editInfo.propertyGracePeriod = '';
    }
  }

  // 监听长租车辆：一位多车数量
  @Watch('editInfo.monthExceedNumType', { immediate: true })
  onChangeMonthExceedNumType(newVal: string) {
    if (newVal !== '1') {
      // 不限
      this.editInfo.monthExceedNum = '';
    }
  }

  // 监听长租车辆：免费宽限期天数
  @Watch('editInfo.monthGracePeriodType', { immediate: true })
  onChangeMonthGracePeriodType(newVal: string) {
    if (newVal !== '1') {
      // 不限
      this.editInfo.monthGracePeriod = '';
    }
  }

  // 编辑，提交，表单验证
  handleEditSubmit(e: any) {
    e.stopPropagation();
    e.preventDefault();
    this.form.validateFields(async (err: boolean) => {
      if (!err) {
        this.updateData();
      }
    });
  }

  // 重置数据
  async handleResetData() {
    const { detailData } = this;
    this.isDisabled = true;

    if (detailData) {
      await this.resetEditData(detailData);
    } else {
      await this.initData();
    }
  }

  // 修改－请求数据
  async updateData() {
    const { parkId, formParams, editInfo } = this;
    const params = JSON.parse(JSON.stringify(editInfo));

    Object.keys(formParams).forEach(item => {
      if (item === 'propertyExceedNum' || item === 'monthExceedNum') {
        if (editInfo[`${item}Type`] === '0') {
          params[item] = 0;
        }
      } else if (item === 'propertyGracePeriod' || item === 'monthGracePeriod') {
        switch (editInfo[`${item}Type`]) {
          case '0':
            params[item] = 0;
            break;
          case '2':
            params[item] = 9999;
            break;
        }
      }
    });
    let enumRecordRequestModelList: any[] = [];
    if (this.showWhyflag) {
      for (let i = 0; i < this.manualLiftList.length; i++) {
        if (this.manualcheck.find(item => item === this.manualLiftList[i].enumCode) > -1) {
          this.manualLiftList[i].usedStatus = '01';
        } else {
          this.manualLiftList[i].usedStatus = '00';
        }
      }
      for (let j = 0; j < this.abnormalReasonList.length; j++) {
        if (this.abnormalcheck.find(item => item === this.abnormalReasonList[j].enumCode) > -1) {
          this.abnormalReasonList[j].usedStatus = '01';
        } else {
          this.abnormalReasonList[j].usedStatus = '00';
        }
      }
      if (this.manualcheck.length < 1) {
        return this.$message.warning('手动抬杆原因至少勾选一个');
      }
      if (this.abnormalcheck.length < 1) {
        return this.$message.warning('特殊放行原因至少勾选一个');
      }
      let sdtg = { enumType: '01', enumRecordList: this.manualLiftList };
      let ycsz = { enumType: '02', enumRecordList: this.abnormalReasonList };
      enumRecordRequestModelList = [sdtg, ycsz];
    }

    // let { propertyExceedNum, propertyGracePeriod, monthExceedNum, monthGracePeriod, monthRetentionPeriod } = params
    const {
      masterSlaveCar,
      changeCar,
      unconsciousPayFlag,
      unconsciousPaySource,
      freeTime,
      monthRetentionPeriod
    } = params;

    if (!String(freeTime)) {
      return this.$message.warning('请输入出场时间');
    } else if (!/^[0-9]+?$/.test(freeTime)) {
      return this.$message.warning('出场时间只能为非负整数');
    } else if (freeTime > 99) {
      return this.$message.warning('出场时间最大为99');
    }
    try {
      this.spinning = true;
      const { status, msg } = await editPassRuleAPI({
        parkId,
        masterSlaveCar,
        changeCar,
        unconsciousPaySource,
        unconsciousPay: unconsciousPayFlag ? '01' : '00',
        pkUniformruleId: this.pkUniformruleId,
        enumRecordRequestModelList,
        freeTime: String(freeTime),
        monthRetentionPeriod
      });
      if (status === '9999') {
        this.isDisabled = true;
        this.setTime = setTimeout(() => {
          this.$message.success('保存成功');
          this.initData();
        }, 1500);
      } else {
        this.$message.error(msg || '保存失败！');
      }
    } catch (error) {
      // console.log(error)
      this.$message.error((error && error.msg) || '保存失败！');
    } finally {
      this.setTime = setTimeout(() => {
        this.spinning = false;
      }, 1500);
    }
  }
  setTime: any = undefined;
  destroyed() {
    clearTimeout(this.setTime);
  }
  handlesdtgchange(val: any) {
    if (val.length > 9) {
      this.manualcheck.length = 9;
      return this.$message.warning('最多只能勾选9个');
      // this.manualcheck = val.prop
    }
  }
  handletsfxchange(val: any) {
    if (val.length > 9) {
      this.abnormalcheck.length = 9;
      return this.$message.warning('最多只能勾选9个');
      // this.manualcheck = val.prop
    }
  }
  showWhyflag = true;
  manualLiftList: any[] = []; //手动抬杆记录
  manualcheck: any[] = [];
  abnormalReasonList: any[] = []; //异常原因设置
  abnormalcheck: any[] = [];
  // 获取编辑详情数据
  async getEditInfoData() {
    try {
      const { parkId } = this;

      const { status, msg, data } = await getPassRuleDetailAPI({
        parkId
      });

      if (status === '9999') {
        this.detailData = data;
        if (data.flag === false) {
          this.showWhyflag = data.flag;
        } else {
          this.showWhyflag = true;
        }
        if (this.showWhyflag) {
          if (data && data.responseModelList && data.responseModelList[0].enumType === '01') {
            this.manualLiftList = data.responseModelList[0].enumRecordList;
          } else {
            this.manualLiftList = data.responseModelList[1].enumRecordList;
          }
          if (data && data.responseModelList && data.responseModelList[1].enumType === '02') {
            this.abnormalReasonList = data.responseModelList[1].enumRecordList;
          } else {
            this.abnormalReasonList = data.responseModelList[0].enumRecordList;
          }
          let sdtgList = [];
          for (let i = 0; i < this.manualLiftList.length; i++) {
            if (this.manualLiftList[i].usedStatus === '01') {
              sdtgList.push(this.manualLiftList[i].enumCode);
            }
          }
          let ycglList = [];
          for (let j = 0; j < this.abnormalReasonList.length; j++) {
            if (this.abnormalReasonList[j].usedStatus === '01') {
              ycglList.push(this.abnormalReasonList[j].enumCode);
            }
          }
          this.manualcheck = sdtgList;
          this.abnormalcheck = ycglList;
        }
      } else {
        this.$message.error(msg || '获取详情失败！');
      }
    } catch (e) {
      this.$message.error((e && e.msg) || '获取详情失败！');
    }
    return this.detailData;
  }

  // 重置编辑表单
  async resetEditData(detailData: any) {
    if (detailData) {
      // 修改
      this.form = this.$form.createForm(this, {});
      this.pkUniformruleId = detailData.pkUniformruleId || null;
      Object.keys(this.formParams).forEach(item => {
        if (item === 'propertyExceedNum' || item === 'monthExceedNum') {
          if (detailData[item] !== null || detailData[item] !== undefined) {
            this.editInfo[item] = detailData[item];
            this.editInfo[`${item}Type`] = detailData[item] > 0 ? '1' : '0';
          }
        } else if (item === 'propertyGracePeriod' || item === 'monthGracePeriod') {
          if (detailData[item] !== null || detailData[item] !== undefined) {
            this.editInfo[item] = detailData[item];
            switch (+detailData[item]) {
              case 0:
                this.editInfo[`${item}Type`] = '0';
                break;
              case 9999:
                this.editInfo[`${item}Type`] = '2';
                break;
              default:
                this.editInfo[`${item}Type`] = '1';
            }
          }
        } else if (item === 'changeCar') {
          this.editInfo[item] = detailData[item] || '01';
        } else if (item === 'masterSlaveCar') {
          this.editInfo[item] = detailData[item] || '00';
          if (detailData[item]) {
            // @ts-ignore
            this.value = [detailData[item]];
          } else {
            this.value = [];
          }
        } else if (item == 'unconsciousPay') {
          this.editInfo[item] = detailData[item] || '00';
          this.editInfo['unconsciousPayFlag'] = this.editInfo[item] == '01';
        } else if (item == 'unconsciousPaySource') {
          this.editInfo[item] = detailData[item] || '';
        } else if (item == 'freeTime') {
          this.editInfo[item] = detailData[item] || '0';
        } else if (item == 'monthRetentionPeriod') {
          this.editInfo[item] = typeof detailData[item] === 'number' ? detailData[item] : null;
        } else {
          this.editInfo[item] = detailData[item] || '';
        }
      });
      this.editInfo = { ...this.editInfo };
    } else {
      this.pkUniformruleId = null;
    }
  }

  // 初始化数据
  async initData() {
    const { parkId } = this;
    this.isDisabled = true;
    let detailData;

    if (parkId) {
      detailData = await this.getEditInfoData();
    }

    await this.resetEditData(detailData);
  }
  //切换车辆停车地点
  changeCarStatus(e: { target: { value: string } }) {
    if (e.target.value == '00') {
      this.value = [];
    }
    this.formParams.masterSlaveCar = this.value.length > 0 ? '01' : '00';
    this.editInfo.masterSlaveCar = this.value.length > 0 ? '01' : '00';
  }

  handleLangCar(num) {
    this.formParams.monthRetentionPeriod = num;
    this.editInfo.monthRetentionPeriod = num;
  }

  // 生命周期初始化
  async created() {
    // await this.initData()
  }

  async activated() {
    this.initData();
  }
}
